import { CircularProgress } from "@mui/material";
import { FC } from "react";

interface Props {
	size: number;
}

const RiskSpinner: FC<Props> = ({ size }) => <CircularProgress size={size} disableShrink sx={{ color: '#ffffff' }}/>;

export default RiskSpinner;
